import { render, staticRenderFns } from "./vendorBadRecord.vue?vue&type=template&id=236a9991&scoped=true"
import script from "./vendorBadRecord.vue?vue&type=script&lang=js"
export * from "./vendorBadRecord.vue?vue&type=script&lang=js"
import style0 from "./vendorBadRecord.vue?vue&type=style&index=0&id=236a9991&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a9991",
  null
  
)

export default component.exports